import React from "react";
import { Pagination } from "react-bootstrap";
import { Link } from "react-router-dom";

const ListDataKategoriDataCompOpenData = React.memo(({items, currentPage, totalItems, itemsPerPage, onPageChange,startItem, endItem, formatDate, loading,totalPages}) => {
    // const totalPages = Math.ceil(totalItems / itemsPerPage)

    /* const createPaginationItems = () => {
        let paginationItems = [];
        for (let number = 1; number <= totalPages; number++) {
            paginationItems.push(
                <Pagination.Item key={number} active={number === currentPage} onClick={() => onPageChange(number)}>
                    {number}
                </Pagination.Item>
            );
        }
        return paginationItems;
    }; */
    const modifyUrl = (url) => {
        // Memisahkan URL menjadi dua bagian
        // const parts = url.split('208');
        
        // Menambahkan :24965 setelah 208
        // const modifiedUrl = `${parts[0]}208:24965${parts[1]}`;
        
        return url;
    };

    return(
        <section className="d-flex align-items-center">
            <div className="container">
                <div className="row content justify-content-center">
                    <div className="col-md-12">
                        <h4 className="m-b-20" data-aos="fade-left"><i className="bx bx-data"></i> Total <b>{totalItems}</b> Data Kategori</h4>
                        <br/>
                        {/* <h4 className="m-b-20" data-aos="fade-left"><i className="bx bx-data"></i> Page ke <b>{currentPage}</b> Menampilkan <b>{startItem} - {endItem}</b> dari <b>{totalItems}</b> Kategori</h4>
                        <br/> */}
                    </div>
                    {
                        loading ? (
                            <div className="col-md-12 text-center" >
                                <h4>Loading Data...</h4>
                            </div>
                        ) :
                        (
                            items.length > 0 ? (
                                items.map((data, index) => (
                                    <div className="col-md-2 col-sm-4" data-aos="fade-in" key={index}>
                                        <Link to={`/open_data/kategori/${data.name}`} className="box-news" title={data.title ? data.title : '-'}>
                                            <div className="box-news-img">
                                                {/* <img src={`${process.env.PUBLIC_URL}/sampang.png`} className="testimonial-img" alt="" /> */}
                                                {
                                                    !data.image_display_url ? 'Loading Data' : (
                                                        <img src={modifyUrl(data.image_display_url)} alt="" />
                                                    )
                                                }
                                            </div>
                                            <div className="box-content-news-center">
                                                <h3 className="text-center">{data.title ? data.title : '-'}</h3>
                                                <h3 className="text-center font-weight-700">{data.package_count}</h3>
                                            </div>
                                            <div className="bottom-div text-center">
                                                <i className="bx bx-time"></i> {formatDate(data.created)}
                                            </div>
                                        </Link>
                                    </div>
                                ))
                            ): (
                                <div className="col-lg-12 box-no-data"> No Data Found</div>
                            )
                        )
                    }
                    {/* <div className="col-md-12">
                        <br /><br />
                        {
                            items.length !==0 ? (
                                <Pagination className="d-flex justify-content-center">
                                    <Pagination.Prev 
                                        onClick={() => onPageChange(currentPage - 1)} 
                                        disabled={currentPage === 1}
                                    />
                                    {createPaginationItems()}
                                    <Pagination.Next 
                                        onClick={() => onPageChange(currentPage + 1)} 
                                        disabled={currentPage === totalPages}
                                    />
                                </Pagination>
                            ) : ('')
                        }
                        
                        
                    </div> */}
                    
                </div>
            </div>
        </section>
    )
})

export default ListDataKategoriDataCompOpenData;